import React from 'react';
import { useParallax } from 'react-scroll-parallax';

// Asset URLs
const BUBBLES_BLUE =
  'https://santaplaya-bucket.s3.amazonaws.com/bubbles_blue.webp';
const BLUE_FISH = 'https://santaplaya-bucket.s3.amazonaws.com/blue_fish.webp';
const BLUE_PRAWN = 'https://santaplaya-bucket.s3.amazonaws.com/blue_prawn.webp';

const ChefParallaxAccents: React.FC = () => {
  /*
   * We define parallax hooks for each image so we can control their motion.
   * Feel free to adjust numeric arrays to get the desired speed/range.
   */
  const bubblesLeftRef = useParallax<HTMLImageElement>({
    translateY: [20, -20],
    easing: 'easeInOut',
  });
  const fishLeftRef = useParallax<HTMLDivElement>({
    translateX: [15, -15],
    easing: 'easeInOut',
  });
  const prawnRef = useParallax<HTMLDivElement>({
    rotate: [-3, 3],
    easing: 'easeInOut',
  });
  const fishRightRef = useParallax<HTMLDivElement>({
    translateX: [-20, 20],
    easing: 'easeInOut',
  });
  const bubblesRightRef = useParallax<HTMLImageElement>({
    translateY: [30, -30],
    easing: 'easeInOut',
  });

  return (
    <div className="absolute inset-0 pointer-events-none z-0">
      {/* LEFT SIDE accents from top to bottom */}
      {/* 1) Bubbles top-left */}
      <img
        src={BUBBLES_BLUE}
        ref={bubblesLeftRef.ref}
        alt="Bubbles Left"
        className="absolute top-[10%] left-1/4 w-[8vw] "
      />

      {/* 2) Fish (flipped) middle-left */}
      <div
        ref={fishLeftRef.ref}
        className="absolute top-[25%] -left-[12.5%] w-[40vw]"
      >
        <img src={BLUE_FISH} alt="Fish Left Flipped" className="scale-x-[-1]" />
      </div>

      {/* 3) Prawn bottom-left */}
      <div
        ref={prawnRef.ref}
        className="absolute bottom-[20%] left-[10%] w-[12vw]"
      >
        <img src={BLUE_PRAWN} className="rotate-[150deg]" alt="Blue Prawn" />
      </div>

      {/* RIGHT SIDE accents from bottom to top */}
      {/* 4) Fish (flipped) near bottom-right */}
      <div
        ref={fishRightRef.ref}
        className="absolute bottom-8 -right-[20%]  w-[40vw]"
      >
        <img
          src={BLUE_FISH}
          alt="Fish Right Flipped"
          className="scale-x-[-1]"
        />
      </div>

      {/* 5) Bubbles mid-right */}
      <img
        src={BUBBLES_BLUE}
        ref={bubblesRightRef.ref}
        alt="Bubbles Right"
        className="absolute top-[30%] right-[12.5%] w-[15vw]"
      />
    </div>
  );
};

export default ChefParallaxAccents;
